import Vue from 'vue'
import App from './app'
import store from '@state/store'
import modules from '@modules'
import router from '@router'
// import '@components/_globals'
import VueNotify from 'vue-notifyjs'
import BootstrapVue from 'bootstrap-vue'
// import socketio from 'socket.io-client'
// import VueSocketIO from 'vue-socket.io'

import 'es6-promise/auto'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(VueNotify)

Vue.prototype.$toast = function(error, type) {
  var _icon = 'info'
  var _type = 'info'
  if (type === 'success') {
    _type = type
    _icon = 'check'
  } else if (type === 'warning') {
    _type = type
    _icon = 'exclamation'
  } else if (type === 'danger' || type === 'error') {
    _type = 'danger'
    _icon = 'times'
  }

  let _message = error
  if (error && error.response && error.response.data) {
    _message = error.response.data.Message
  }

  this.$notify({
    message: _message,
    icon: `fas fa-${_icon}-circle ${_icon}-circle`,
    horizontalAlign: 'right',
    verticalAlign: 'top',
    type: _type.toString(),
    showClose: true,
    // timeout: 100000,
  })
}

// If running inside Cypress...
// if (window.Cypress) {
//   // Ensure tests fail when Vue emits an error.
//   Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
// }

// export const SocketInstance = socketio('http://localhost:8081')
// Vue.use(VueSocketIO, SocketInstance)

// var socket = SocketInstance.connect()

// socket.on('connected', function(data) {
//   // this.$toast(data.message, 'success')
//   console.log(data.message)
// })

// socket.on('notification', function(data) {
//   console.log(data.message)
// })

// console.log('Initializing Paladin Modules Plugin...')
// Vue.use(PaladinModulesPlugin)

// const modules = new PaladinModulesPlugin()

// console.log(Vue.$moduleRoutes)

new Vue({
  modules,
  router,
  store,
  created() {},
  render: (h) => h(App),
}).$mount('#app')
